import { useSelection } from "../../contexts/SelectionContext";
import { Card } from "../../types";
import { Button } from "@/components/ui/button";
import { sendTrackDataServer } from "@/features/analytics/utils/serverTrackData";

interface LongListSelectionFooterProps {
  totalCount: number;
  cards: Card[];
  onContinue: () => void;
  isLoading: boolean;
  dealId: string | null;
  longListId: string | null;
}

export function LongListSelectionFooter({
  totalCount,
  cards,
  onContinue,
  isLoading,
  dealId,
  longListId,
}: LongListSelectionFooterProps) {
  const { selectionCount, selectAll, clearSelection } = useSelection();
  const allSelected = selectionCount === totalCount && totalCount > 0;

  const handleToggleAll = () => {
    if (allSelected) {
      clearSelection();
    } else {
      selectAll(cards.map((c) => c.id));
    }
  };

  const handleContinue = () => {
    sendTrackDataServer({
      eventName: "VISION_LONGLIST_CONTINUE_CLICKED",
      productType: "PO",
      data: {
        longlist_id: longListId ?? "",
        user_id: null, // Will be filled by sendTrackDataServer
        email: null, // Will be filled by sendTrackDataServer
        deal_id: dealId ?? null,
        selected_count: selectionCount,
        total_count: totalCount,
      },
      url: location.pathname,
    });
    onContinue();
  };

  return (
    <div className="fixed left-0 right-0 bottom-0 z-40 bg-white border-t py-4 px-6 flex items-center justify-between">
      <div className="flex items-center gap-4">
        <button
          type="button"
          className="flex items-center space-x-2 px-3 py-1 transition-all duration-300 cursor-pointer"
          onClick={handleToggleAll}
          disabled={totalCount === 0}
        >
          <span className="text-sm text-gray-700">
            {allSelected ? "Desmarcar todos" : "Selecionar todos"}
          </span>
          <div
            className={`relative inline-flex h-5 w-9 flex-shrink-0 items-center rounded-full transition-colors focus:outline-none ${
              allSelected ? "bg-primary" : "bg-gray-200"
            }`}
            aria-hidden="true"
          >
            <span
              className={`${
                allSelected ? "translate-x-5" : "translate-x-1"
              } inline-block h-3 w-3 transform rounded-full bg-white transition-transform`}
            />
          </div>
        </button>
        <span className="text-sm">
          ({selectionCount}/{totalCount}) selecionado
          {selectionCount !== 1 ? "s" : ""}
        </span>
      </div>
      <div className="flex items-center gap-4">
        <Button
          onClick={handleContinue}
          disabled={selectionCount === 0 || isLoading}
          className="bg-primary px-6 py-2 rounded flex items-center gap-2"
        >
          {isLoading ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
              Processando...
            </>
          ) : (
            "Continuar"
          )}
        </Button>
      </div>
    </div>
  );
}
